// Modular router configuration - aggregates all feature modules
import Auth from '@/router/Auth.js';
// Import feature modules
import AdminRoutes from '@/router/admin/index.js';
import CorporateRoutes from '@/router/Corporate.js';
import ContentRoutes from '@/router/content/index.js';
import CourseRoutes from '@/router/courses/index.js';
import EbooksRoutes from '@/router/Ebooks.js';
import PeopleRoutes from '@/router/People.js';
import SystemRoutes from '@/router/system/index.js';
import TestingRoutes from '@/router/testing/index.js';

export default [
    // Authentication routes
    ...Auth,

    // Home route - using simple dynamic import as recommended by Vue Router
    {
        path: '/',
        component: () => import('@/pages/Home.vue'),
        meta: {
            title: 'Home',
        },
        children: [
            {
                path: '/',
                name: 'home',
                component: () => import('@/components/dashboard/Dashboard.vue'),
                meta: {
                    title: 'Home',
                },
                props: true,
            },
            // Corporate-only top-level pages live inside the Home.vue shell so
            // they inherit its sidebar registration (Menu/setStaticMenu) and
            // breadcrumb wiring. The CorporateOnly beforeEnter guard on each
            // child record still blocks non-corporate clients at the 403 page.
            ...CorporateRoutes,
        ],
    },

    // Page view route
    {
        path: '/pages/:slug',
        name: 'page-show',
        component: () => import('@/components/pages/pages/PageView.vue'),
        meta: {
            title: 'Home',
        },
        props: true,
    },

    // Feature module routes
    ...CourseRoutes,
    ...AdminRoutes,
    ...ContentRoutes,
    ...EbooksRoutes,
    ...PeopleRoutes,
    ...SystemRoutes,

    // Special utility routes
    {
        name: 'system-alerts',
        path: '/system-alerts/:systemAlertUuid',
        component: () => import('@/pages/SystemAlert.vue'),
        meta: {
            title: 'System Alert',
        },
    },

    {
        name: 'playground',
        path: '/playground',
        component: () => import('@/pages/EdverumPlayground.vue'),
        meta: {
            title: 'Playground',
        },
    },

    {
        name: 'component-playground',
        path: '/component-playground',
        component: () => import('@/pages/ComponentPlayground.vue'),
        meta: {
            title: 'Component Playground',
        },
    },

    ...TestingRoutes,

    // Authentication and error routes
    {
        name: 'logout',
        path: '/logout',
        component: () => import('@/pages/Logout.js'),
        meta: {
            title: 'Logout',
        },
    },

    {
        name: '403',
        path: '/restricted',
        component: () => import('@/pages/errors/NoAccess.vue'),
        props: route => ({
            deniedPath: route.query.deniedPath || '',
            fromPath: route.query.fromPath || '',
        }),
        meta: {
            title: 'Restricted',
        },
    },

    {
        name: '404',
        path: '/:pathMatch(.*)*',
        component: () => import('@/pages/errors/NotFound.vue'),
        meta: {
            title: 'Page Not Found',
        },
    },
];
